<template>
<SvgColorCycler
    :lastAnimationDate="lastAnimationDate"
    :options="options"
/>
</template>

<script>
// This is a singleton component, and isn't rendered in the viewport.
// Use BountyIconSymbolRef to display the icon. The animations
// will be synced across all component instances.
import { mapState } from 'vuex'

import * as COLORS from '@/color-cycler/colors'
import { createDiamond } from '@/color-cycler/shapes'
import SvgColorCycler from '@/color-cycler/SvgColorCycler'

const colorValues = Object.values(COLORS)

export default {
    name: 'BountyIconSymbol',
    data: () => ({
        lastAnimationDate: null,
        runCount: 0,
        options: {
            shape: createDiamond(),
            flow: [],
            colors: [],
            numCycles: 1,
            interruptible: true,
        },
    }),
    computed: mapState(['listRenderCount']),
    watch: {
        async listRenderCount () {
            // The bounty animation should mirror the BroadcasterLikes
            // animation, in terms of delay and interval.
            await sleep(1250)
            this.runAnimation()

            clearInterval(this.intervalId)
            this.intervalId = setInterval(this.runAnimation, 10 * 1000)
        }
    },
    methods: {
        runAnimation () {
            const { shape } = this.options
            const flowsList = Object.values(shape.flows)
            const flowIndex = this.runCount % flowsList.length
            this.options.flow = flowsList[flowIndex]

            const colorIndex = this.runCount % colorValues.length
            this.options.colors = colorValues[colorIndex]

            this.lastAnimationDate = new Date()
            this.runCount++
        }
    },
    components: {
        SvgColorCycler
    }
}

</script>

<style lang="scss" scoped>

</style>
